export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["DRAFT"] = "DRAFT";
    InvoiceStatus["APPROVED"] = "APPROVED";
    InvoiceStatus["SENT"] = "SENT";
    InvoiceStatus["CANCELLED"] = "CANCELLED";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["OVERDUE"] = "OVERDUE";
})(InvoiceStatus || (InvoiceStatus = {}));
